import { useSelector } from 'react-redux';
import { Stack } from '@mui/material';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { RecipientField } from 'components/shared/sharing/RecipientField';

import { usePropertyDrawers } from 'hooks/usePropertyDrawers';
import { useShareProperty } from 'hooks/useShareProperty';

import { PeopleWithAccess } from 'components/shared/sharing/PeopleWithAccess';
import { EntityFileDetails } from 'components/shared/EntityFileDetails';
import { IllustrationProperties } from 'components/shared/illustrations/IllustrationProperties';

export const ShareProperty = () => {
  const selectedProperty = useSelector((state) => state.properties.selectedProperty);
  const currentUser = useSelector((state) => state.auth.currentUser);

  const { openDrawerPropertyDetails } = usePropertyDrawers();
  const { userList, usersLoading, sharedUserList, handleSearchUser, handleShareProperty, handleUpdateShareProperty } =
    useShareProperty(selectedProperty?.id, currentUser);

  const handleCancel = () => {
    openDrawerPropertyDetails();
  };

  return (
    <DrawerContent>
      <DrawerContent.Header title={selectedProperty?.id ? `Share ${selectedProperty?.name}` : ''} />
      <DrawerContent.Wrapper>
        {!selectedProperty && (
          <EntityFileDetails.EmptyFile
            illustration={
              <IllustrationProperties
                width={220}
                height={180}
              />
            }
            title="Select a property to view file details"
          />
        )}
        {selectedProperty && (
          <>
            <Stack spacing={2}>
              <RecipientField
                optionsData={userList}
                backendSearch={handleSearchUser}
                loading={usersLoading}
                handleShare={handleShareProperty}
              />
              <PeopleWithAccess>
                <PeopleWithAccess.Account>
                  <PeopleWithAccess.AccountName accountName={currentUser.name} />
                  <PeopleWithAccess.AccountAccess accountAccess="Owner" />
                </PeopleWithAccess.Account>
                {sharedUserList.map((user, index) => (
                  <PeopleWithAccess.Account key={`${user.owner_account.id}-${index}`}>
                    <PeopleWithAccess.AccountName accountName={user.owner_account.name} />
                    <PeopleWithAccess.AccessOptions
                      value={user.access.includes('Write') ? 'Write' : 'Read'}
                      onChange={(access) => handleUpdateShareProperty(user.owner_account.id, access)}
                    />
                  </PeopleWithAccess.Account>
                ))}
              </PeopleWithAccess>
            </Stack>
            <DrawerContent.CancelButton cancel={handleCancel} />
          </>
        )}
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
